import axios from 'axios';
import UrlsUtil from '../../utils/url.util';

const apiBaseUrl = UrlsUtil.determineApiBaseUrl(window);
const apiKey = `${process.env.REACT_APP_APIKEY}`;

console.log('abu:', apiBaseUrl);

export default class SummaryService {
  static activate = async (customerId: string, entityId: string, entityType: string): Promise<any> => {
    const url = `${apiBaseUrl}/api/Event/${customerId}/${entityType}/${entityId}/activate`;
    let authToken = window.localStorage.getItem('basicAuthHeader')
    return await axios.put(url, { headers: { 'apiKey': apiKey, 'Authorization': authToken } });
  };

  static deactivate = async (customerId: string, entityId: string, entityType: string, flowKey: string): Promise<any> => {
    const url = `${apiBaseUrl}/api/Event/${customerId}/${entityType}/${entityId}`;
    let authToken = window.localStorage.getItem('basicAuthHeader')
    return await axios.delete(url, { headers: { 'apiKey': apiKey, 'Authorization': authToken, 'flowKey': flowKey } });
  };

  static delete = async (customerId: string, entityId: string, entityType: string, flowKey: string): Promise<any> => {
    const url = `${apiBaseUrl}/api/Event/${customerId}/${entityType}/${entityId}/hard`;
    let authToken = window.localStorage.getItem('basicAuthHeader')
    return await axios.delete(url, { headers: { 'apiKey': apiKey, 'Authorization': authToken, 'flowKey': flowKey } });
  };

  static getAll = async (startDate: string | undefined, endDate: string | undefined): Promise<any> => {
    const url = `${apiBaseUrl}/api/Summary`;
    let authToken = window.localStorage.getItem('basicAuthHeader')
    var headers = { headers: { 'apiKey': apiKey, 'Authorization': authToken, 'startDate': startDate, 'endDate': endDate } }
    return await axios.get(url, headers);
  };

  static getAllFor = async (customerId: string, entityId: string, entityType: string): Promise<any> => {
    const url = `${apiBaseUrl}/api/Event/${customerId}/${entityType}/${entityId}/all`;
    let authToken = window.localStorage.getItem('basicAuthHeader')
    return await axios.get(url, { headers: { 'apiKey': apiKey, 'Authorization': authToken } });
  };

  static getEntireFor = async (customerId: string, entityId: string, entityType: string): Promise<any> => {
    const url = `${apiBaseUrl}/api/Event/${customerId}/${entityType}/${entityId}/entire`;
    let authToken = window.localStorage.getItem('basicAuthHeader')
    return await axios.get(url, { headers: { 'apiKey': apiKey, 'Authorization': authToken } });
  };
};